module.exports = __webpack_public_path__ + "img/p3.466e3236.png";